/**
 * App root — React Router with auth-protected routes.
 * Phase 23.6 — ErrorBoundary, ToastProvider, 404 catch-all.
 */

import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { SystemModeProvider } from './context/SystemModeContext';
import { ErrorBoundary, ToastProvider } from './components/common';
import AppLayout from './components/layout/AppLayout';
import ProtectedRoute from './components/layout/ProtectedRoute';

// Pages
import LoginPage from './pages/LoginPage';
import DashboardPage from './pages/DashboardPage';
import JobDetailPage from './pages/JobDetailPage';
import ArchivedJobsPage from './pages/ArchivedJobsPage';
import QuotesPage from './pages/QuotesPage';
import ManagePage from './pages/ManagePage';
import ReportsPage from './pages/ReportsPage';
import SettingsPage from './pages/SettingsPage';
import EmailReviewPage from './pages/EmailReviewPage';
import DocumentsPage from './pages/DocumentsPage';
import TodoPage from './pages/TodoPage';
import PackingSlipReviewPage from './pages/PackingSlipReviewPage';
import NotFoundPage from './pages/NotFoundPage';

export default function App() {
  return (
    <ErrorBoundary>
      <BrowserRouter>
        <AuthProvider>
          <SystemModeProvider>
            <ToastProvider>
            <Routes>
              {/* Public route */}
              <Route path="/login" element={<LoginPage />} />

              {/* Protected routes */}
              <Route
                element={
                  <ProtectedRoute>
                    <AppLayout />
                  </ProtectedRoute>
                }
              >
                <Route index element={<DashboardPage />} />
                <Route path="jobs/:id" element={<JobDetailPage />} />
                <Route path="jobs/archived" element={<ArchivedJobsPage />} />
                <Route path="quotes" element={<QuotesPage />} />
                <Route path="manage" element={<ManagePage />} />
                <Route path="reports" element={<ReportsPage />} />
                <Route path="settings" element={<SettingsPage />} />
                <Route path="documents" element={<DocumentsPage />} />
                <Route path="email-review" element={<EmailReviewPage />} />
                <Route path="receiving-review" element={<PackingSlipReviewPage />} />
                <Route path="todos" element={<TodoPage />} />
                <Route path="*" element={<NotFoundPage />} />
              </Route>
            </Routes>
            </ToastProvider>
          </SystemModeProvider>
        </AuthProvider>
      </BrowserRouter>
    </ErrorBoundary>
  );
}
